import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-arrow-navigation/jb-arrow-navigation.css.ts
var jb_arrow_navigation_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{align-items:center;block-size:40px;display:flex}button{appearance:none;background:rgba(0,0,0,0);border:0;color:inherit;display:inline;padding:0}button:disabled{opacity:.2}.arrow-navigation{align-items:center;display:flex;gap:var(--theme-spacing-s)}`;

export {
  jb_arrow_navigation_css_default
};
